import { action, observable } from 'mobx';
import { LatestNewsController } from 'cd-eft/services/eftPrjAdminApi';
import { AnnouncementDto, AnnouncementRequestDto } from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';
import { isValidUrl } from 'cd-eft/utils/stringUtilities';

interface OutputObject {
  id?: number;
  title?: string;
  lastChangeDate?: string;
}
export class LatestNewsVM {
  constructor() {
    /* */
  }
  @observable editAnnouncement: AnnouncementRequestDto = {};
  @observable newAnnouncement: AnnouncementRequestDto = {};
  @observable adminContent: boolean | undefined = false;
  @observable validURL: boolean = false;
  @observable selectedData: string[] = [];
  @observable checkedLatestnews: any[] = [];
  @observable latestNews: AnnouncementDto[] = [];
  @observable deleteClicked: boolean = false;
  @observable editClicked: boolean = false;
  @observable finalDeleteClicked: boolean = false;
  @observable deletePopup: boolean = false;
  @observable addButtonClicked: boolean = false;
  @observable saveButtonPopup: boolean = false;
  @observable saveUpdateButtonPopup: boolean = false;
  @observable formValidation = {
    hasError: false,
    announcementText: false,
    announcementTextLink: false,
    formErrors: {
      announcementText: '',
      announcementTextLink: '',
    },
  };
  @action.bound async getLatestNews() {
    try {
      const response: any = await LatestNewsController.getAllAnnouncementsUsingGET();
      //to sort the list in descenc order by date and select 5 from the top.
      const toplatestNews = response.data
        .filter((obj) => obj.viewOrder >= 1)
        .sort((a, b) => {
          return a.viewOrder - b.viewOrder;
        });
      const buttomLatestNews = response.data
        .filter((obj) => obj.viewOrder == 0 || obj.viewOrder == null)
        .sort((a, b) => {
          return Date.parse(b.creationDateUtc) - Date.parse(a.creationDateUtc);
        });
      if (response && response.data && !this.adminContent) {
        this.latestNews = toplatestNews;
        // .sort((a, b) => {
        //   return Date.parse(b.creationDateUtc) - Date.parse(a.creationDateUtc);
        // })
        // .slice(0, 5);
      }
      if (this.adminContent && response.data) {
        this.latestNews = toplatestNews.concat(buttomLatestNews);
      }
    } catch (error) {
      console.error(error);
    }
  }

  @action.bound errorClass(field) {
    const errorMessage = this.formValidation.formErrors[field];
    return errorMessage?.length === 0 ? 'edit-add-announcement-input' : 'edit-add-announcement-input usa-input--error';
  }

  @action.bound async deleteSelectedNews(id) {
    try {
      await LatestNewsController.deleteAnnouncementByIdUsingDELETE(id);
      await LatestNewsController.getAllAnnouncementsUsingGET();
    } catch (error) {
      console.error(error);
    }
  }
  @action.bound async addAnnouncementHandler() {
    try {
      this.editClicked = false;
      this.saveButtonPopup = false;
      this.addButtonClicked = false;
      const overwriteObjReq = this.latestNews.find((obj) => obj.viewOrder == this.newAnnouncement.viewOrder);
      if (overwriteObjReq) {
        this.newAnnouncement.overwriteAnnouncementId = overwriteObjReq?.announcementId;
      }
      await LatestNewsController.addOrUpdateNewAnnouncementUsingPOST(this.newAnnouncement);
      this.getLatestNews();
    } catch (error) {
      console.error(error);
    }
  }
  @action.bound async updateAnnouncementHandler(id) {
    try {
      this.editClicked = false;
      this.saveUpdateButtonPopup = false;
      this.addButtonClicked = false;
      const overwriteObjReq = this.latestNews.find((obj) => obj.viewOrder == this.editAnnouncement.viewOrder);
      if (overwriteObjReq && overwriteObjReq.announcementId !== this.editAnnouncement.announcementId) {
        this.editAnnouncement.overwriteAnnouncementId = overwriteObjReq?.announcementId;
      }
      await LatestNewsController.addOrUpdateNewAnnouncementUsingPOST(this.editAnnouncement);
      this.getLatestNews();
    } catch (error) {
      console.error(error);
    }
  }

  @action.bound handleDataFromChild = (data: string, checked: boolean) => {
    if (checked) {
      this.selectedData.push(data);
    } else {
      const index = this.selectedData.findIndex((el) => el === data);
      if (index !== -1) {
        this.selectedData.splice(index, 1);
      }
    }
  };

  @action.bound async deleteDataHandler() {
    this.selectedData.forEach((id) => this.deleteSelectedNews(id));
    this.deleteClicked = false;
    this.finalDeleteClicked = true;
    this.deletePopup = false;
    this.selectedData = [];
  }

  @action.bound handleDeleteClicked() {
    this.deleteClicked = !this.deleteClicked;
  }

  @action.bound handleEditClicked = (id) => {
    this.editAnnouncement = {
      announcementId: 0,
      announcementText: '',
      announcementTextLink: '',
      createdBy: '',
      lastChangedBy: '',
      overwriteAnnouncementId: 0,
      priority: 0,
      viewOrder: 0,
    };
    this.addButtonClicked = false;

    this.formValidation = {
      hasError: false,
      announcementText: false,
      announcementTextLink: false,
      formErrors: {
        announcementText: '',
        announcementTextLink: '',
      },
    };

    this.editClicked = !this.editClicked;
    this.addButtonClicked = false;
    const objReq = this.latestNews.find((obj) => obj.announcementId === id);
    const { announcementId, announcementText, announcementTextLink, createdBy, lastChangedBy, priority, viewOrder } = {
      ...objReq,
    };
    this.editAnnouncement = {
      ...this.editAnnouncement,
      announcementId,
      announcementText,
      announcementTextLink,
      createdBy,
      lastChangedBy,
      priority,
      viewOrder,
    };
  };

  @action.bound handleAddClicked() {
    this.newAnnouncement = {
      announcementId: 0,
      announcementText: '',
      announcementTextLink: '',
      createdBy: '',
      lastChangedBy: '',
      overwriteAnnouncementId: 0,
      priority: 0,
      viewOrder: 0,
    };
    this.formValidation = {
      hasError: false,
      announcementText: false,
      announcementTextLink: false,
      formErrors: {
        announcementText: '',
        announcementTextLink: '',
      },
    };
    this.editClicked = false;
    this.addButtonClicked = !this.addButtonClicked;
  }

  @action.bound toggleSavePopup() {
    this.validateInput(this.newAnnouncement.announcementText, 'announcementText');
    this.validateInput(this.newAnnouncement.announcementTextLink, 'announcementTextLink');
    if (!this.formValidation.hasError) {
      this.saveButtonPopup = !this.saveButtonPopup;
    }
  }

  @action.bound toggleUpdateSavePopup() {
    this.validateInput(this.editAnnouncement.announcementText, 'announcementText');
    this.validateInput(this.editAnnouncement.announcementTextLink, 'announcementTextLink');
    if (!this.formValidation.hasError) {
      this.saveUpdateButtonPopup = !this.saveUpdateButtonPopup;
    }
  }

  @action.bound handleInputChange(event) {
    //  event.preventDefault;
    const { name, value } = event.target;
    this.validateInput(value, name);
    this.newAnnouncement[name] = value;
  }
  @action.bound handleUpdateInputChange(event) {
    //  event.preventDefault;
    const { name, value } = event.target;
    this.validateInput(value, name);
    this.editAnnouncement[name] = value;
  }

  @action.bound validateInput(value, name) {
    switch (name) {
      case 'announcementText':
        if (value === '') {
          this.formValidation.announcementText = true;
          this.formValidation.formErrors.announcementText = 'Latest News text must not be empty';
          this.formValidation.hasError = true;
        } else {
          this.formValidation.announcementText = false;
          this.formValidation.formErrors.announcementText = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'announcementTextLink':
        this.validURL = isValidUrl(value);
        if (!this.validURL && value?.length) {
          this.formValidation.announcementTextLink = true;
          this.formValidation.formErrors.announcementTextLink = 'Please enter a valid URL';
          this.formValidation.hasError = true;
        }
        else if (value === '') {
          this.formValidation.announcementTextLink = true;
          this.formValidation.formErrors.announcementTextLink = 'Latest News link must not be empty';
          this.formValidation.hasError = true;
        } else {
          this.formValidation.announcementTextLink = false;
          this.formValidation.formErrors.announcementTextLink = '';
          this.formValidation.hasError = false;
        }
        break;
    }
  }

  @action.bound toggleDeletePopup() {
    this.checkedLatestnews = [];
    this.deletePopup = !this.deletePopup;

    this.selectedData.forEach((id) => {
      const result = this.getCheckedObjectInfo(`${id}`);
      this.checkedLatestnews.push(result);
    });
  }

  @action.bound getCheckedObjectInfo(id) {
    for (const obj of this.latestNews) {
      if (obj.announcementId === parseInt(id)) {
        const newObj = {
          id: obj.announcementId,
          title: obj.announcementText,
          lastChangeDate: obj.lastChangeDateUtc,
        };
        return newObj;
      }
    }
  }
}